window.iFrameResizer = {
      heightCalculationMethod : () => {
         
        
        let ionMainContent = window.document.getElementsByClassName("remove-scroll")[0];
        
        const shadowRoot = ionMainContent?.shadowRoot || null;

        if(shadowRoot){
          const scrollElement = shadowRoot.querySelector(".scroll-y");
          return  Math.max(
            scrollElement.scrollHeight,
            scrollElement.offsetHeight,
            scrollElement.clientHeight
          );
        }

        let documentHeight = Math.max(
          document.body.scrollHeight,
          document.documentElement.scrollHeight,
          document.body.offsetHeight,
          document.documentElement.offsetHeight,
          document.body.clientHeight,
          document.documentElement.clientHeight
        );
        
        return documentHeight;
      }
}